export default __webpack_public_path__ + "static/media/Need_More_Info.3d714b54.png";